import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// A tab that was open before a deploy asks for page chunks that the new build deleted.
// Reload to get the new build. The 10 s guard stops a reload loop.
window.addEventListener('vite:preloadError', (event) => {
  const last = Number(sessionStorage.getItem('chunkReloadAt'))
  if (Date.now() - last < 10000) return
  sessionStorage.setItem('chunkReloadAt', String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)